/**
 * @file 根证书二维码
 * @author zdying
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var visible = _ref.visible,
      url = _ref.url,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;

  if (!visible) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'qrcode', onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
    _react2.default.createElement('img', { src: window.jrQrcode.getQrBase64(url) }),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h3',
        null,
        'Download the root certificate'
      ),
      _react2.default.createElement(
        'p',
        null,
        '1. Scan the QR code to download the root certificate.'
      ),
      _react2.default.createElement(
        'p',
        null,
        '2. Or ',
        _react2.default.createElement(
          'a',
          { href: url },
          'click here'
        ),
        ' to download directly.'
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          'Tips'
        ),
        ': You can ',
        _react2.default.createElement(
          'a',
          { href: 'http://hiproxy.org/configuration/ssl_certificate.html', target: '_blank' },
          'click here'
        ),
        ' to see how to install the configuration certificate'
      )
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./src/page/qrcode.js
// module id = 388
// module chunks = 0